import { HighlightedMessage, ReactCarouselSlider, TranslationMessage } from 'components';

import Button from 'components/buttons/Button';
import { Image } from 'components/Image';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { UrlFirstSegment } from 'utils/global';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import defaultimage from 'assets/images/defaultsquare.png';
import popularsvg from 'assets/images/svg/popularpattern.svg';
import { generateLink } from '.';

interface Props {
	content: {
		[key: string]: any;
	};
	productList?: any;
	type: string;
}

const ProductLayoutFour = ({ content, productList, type }: Props) => {
	const productData = productList;
	const urlFirstSegment = UrlFirstSegment();

	const slidersetting = {
		arrow: true,
		dots: false,
		infinite: productData.length < 3 ? false : true,
		speed: 500,
		slidesToShow: 2.9999,
		slidesToScroll: 1,
		// initialSlide: 0,
		prevArrow: <FiArrowLeft />,
		nextArrow: <FiArrowRight />,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: productData.length < 3 ? false : true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					initialSlide: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};

	if (productData?.length > 0) {
		return (
			<section className="py-5 promosection-one homepagesolution ">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-md-4 col-sm-6">
							<h2 className="font-weight-bold text-danger mb-4">
								<HighlightedMessage data={content} value="text" className="text-success" />
							</h2>
							<h5 className="font-weight-bold text-d-gray mb-4">
								<TranslationMessage data={content} value="subtext" />
							</h5>

							<div className="d-flex flex-column flex-sm-row">
								<Button buttonStyle="btn-gradient--solid" buttonSize="btn--medium" icon type="button" url={content.button_url}>
									<TranslationMessage data={content} value="button_text" />
								</Button>
								<div className="mr-3 mb-2"></div>

								<Button buttonStyle="btn-success--outline" buttonSize="btn--medium" icon type="button" url={content.second_button_url}>
									<TranslationMessage data={content} value="second_button_text" />
								</Button>
							</div>
						</div>

						<div className="col-md-8 col-sm-6 promoslider">
							<ReactCarouselSlider {...slidersetting}>
								{productData.map((product, index) => (
									<div key={index} className="d-block position-relative">
										<div className="grid-with-four-item rounded overflow-hidden">
											<Image className="img-fluid" src={product.thumb_image} onErrorSrc={defaultimage} />
											{/* offer tag */}
											{product.product_popularity == "normal" || "" ? "" : <div className="blinkoffertag" style={{ backgroundImage: `url(${popularsvg})` }}>
												<HighlightedMessage data={product} value="product_popularity" />
											</div>}

											<div className="grid-with-four-item-overlay"></div>

											<div className="grid-with-four-item-details">
												<h5 className="text-success font-weight-bold">
													<TranslationMessage data={product} value="title" />
												</h5>
												<h6 className="text-white mb-4">
													<TranslationMessage data={product} value="short_description" isHtmlParse />
												</h6>
												<div className="grid-card-link-group">
													<Link to={`${urlFirstSegment}/${type}/${product.category_slug}/${product.slug}`}>
														<FormattedMessage id="product.learn-more" />
													</Link>
													{generateLink(product, product.page_header_settings_first_button_link, 'page_header_settings_first_button_text')}
													{/* <Link to={product.page_header_settings_first_button_link}>
														<TranslationMessage data={product} value="page_header_settings_first_button_text" isHtmlParse />
													</Link> */}
												</div>
											</div>
										</div>

										<h5 className="font-weight-bold text-d-gray text-center mt-2">
											<TranslationMessage data={product} value="title" />
										</h5>
									</div>
								))}
							</ReactCarouselSlider>
						</div>
					</div>
				</div>
			</section>
		);
	} else {
		return null;
	}
};

export { ProductLayoutFour };
